<template>
  <div style="margin: 0 auto 5rem; max-width: 960px;">
    <HeaderBar
      view="save"
      :showBar="showHeaderBar"
      @discard="discardModalOpen = true"
      @save="saveChanges($route.params.name)"
    />
    <BackButton
      link="/integration-partners"
      text="Back to Technology partner profiles"
    />
    <ProfileHeading
      :heading="profileData.name"
      class="mb-md"
      :featured-badge="profileData.featured"
      :main-badge="{
        text: badgeStatusFilter('status'),
        class: badgeStatusFilter('statusClass'),
      }"
      :profile-link="{
        href: profileUrl,
        text: isProfilePublic ? 'View profile' : 'Preview profile',
        showPreviewIcon: !isProfilePublic,
      }"
    />
    <StatusContentSection namespace="integrationPartners" />
    <hr style="margin: 2rem 0 !important;" />
    <AboutContentSection
      namespace="integrationPartners"
      :integrationPartner="true"
      :key="aboutSectionKey"
    />
    <MediaContentSection
      namespace="integrationPartners"
      @delete-content="deleteContent"
    />
    <VideoContentSection
      namespace="integrationPartners"
      :integration-partner="true"
      @delete-content="deleteContent"
    />
    <QuoteContentSection
      heading="Testimonial"
      namespace="integrationPartners"
      @delete-content="deleteContent"
    />
    <UseCaseContentSection
      namespace="integrationPartners"
      @delete-content="deleteContent"
    />
    <ResourcesContentSection
      heading="Resources"
      namespace="integrationPartners"
      @delete-content="deleteContent"
    />
    <SupportContentSection namespace="integrationPartners" />
    <CTAContentSection
      namespace="integrationPartners"
      :globalCtaUrl="
        $store.state.vendorDashboard.details.directorySettings.globalCtaUrl
      "
      :globalCtaText="
        $store.state.vendorDashboard.details.directorySettings.globalCtaText
      "
    />

    <FiltersContentSection
      heading="Categories and collections"
      namespace="integrationPartners"
      :options="[
        { label: 'Categories', id: 'categories' },
        { label: 'Collections', id: 'collections' },
      ]"
    />

    <div
      style="display: flex; justify-content: space-between; margin-top: 2rem;"
    >
      <Button
        bType="error"
        v-on:button-click="showModal = true"
        type="button"
        style="margin-right: 8px;"
      >
        Remove Partner
      </Button>
      <Button v-on:button-click="saveChanges($route.params.name)" type="button">
        Save
      </Button>
    </div>

    <DSModal
      v-if="modalOpen"
      :old="false"
      :newButtons="true"
      :modalShowing="true"
      :title="modalOpen.title"
      :description="modalOpen.description"
      @close-modal="modalOpen = false"
      @primary-click="confirmedDelete"
      @secondary-click="modalOpen = false"
    />
    <Modal
      v-if="showModal"
      okText="Remove"
      cancelText="Close"
      header="Remove partner"
      body="This action cannot be undone, are you sure you want to remove this partner?"
      @cancel="showModal = false"
      @confirm="removePartner(profileData.id)"
    />
    <DSModal
      v-if="discardModalOpen"
      :old="false"
      :newButtons="true"
      :modalShowing="true"
      title="Discard changes?"
      description="Are you sure you want to discard all the changes?"
      @close-modal="discardModalOpen = false"
      primaryText="Discard changes"
      secondaryText="Cancel"
      @primary-click="discardChanges"
      @secondary-click="discardModalOpen = false"
    />
  </div>
</template>

<script>
import HeaderBar from '@/components/DesignSystem/HeaderBar';
import Modal from '@/components/Modal';
import DSModal from '@/components/DesignSystem/Modal';
import Button from '@/components/DesignSystem/Button';
import MediaContentSection from '@/components/Shared/ContentSection/MediaContentSection';
import VideoContentSection from '@/components/Shared/ContentSection/VideoContentSection';
import QuoteContentSection from '@/components/Shared/ContentSection/QuoteContentSection';
import BackButton from '@/components/BackButton';
import ResourcesContentSection from '@/components/Shared/ContentSection/ResourcesContentSection';
import { createNamespacedHelpers, mapGetters } from 'vuex';
import { filtersOptions } from '@/views/Dashboard/IntegrationPartners/FiltersOptions';
import AboutContentSection from '@/components/Shared/ContentSection/AboutContentSection';
import UseCaseContentSection from '@/components/Shared/ContentSection/UseCaseContentSection';
import CTAContentSection from '@/components/Shared/ContentSection/CTAContentSection';
import SupportContentSection from '@/components/Shared/ContentSection/SupportContentSection';
import FiltersContentSection from '@/components/Shared/ContentSection/FiltersContentSection';
import ProfileHeading from '@/components/Shared/ContentSection/ProfileHeading';
import StatusContentSection from '@/components/Shared/ContentSection/StatusContentSection';
const { mapActions } = createNamespacedHelpers('integrationPartners');

export default {
  components: {
    StatusContentSection,
    ProfileHeading,
    FiltersContentSection,
    UseCaseContentSection,
    AboutContentSection,
    MediaContentSection,
    VideoContentSection,
    QuoteContentSection,
    HeaderBar,
    ResourcesContentSection,
    SupportContentSection,
    CTAContentSection,
    Modal,
    DSModal,
    Button,
    BackButton,
  },
  data() {
    return {
      showModal: false,
      discardModalOpen: false,
      modalOpen: false,
      toDelete: undefined,
      urlError: false,
      deleteType: undefined,
      aboutSectionKey: 1,
    };
  },
  filters: {
    ...filtersOptions,
  },
  methods: {
    ...mapActions([
      'saveChanges',
      'removePartner',
      'clearPartner',
      'fetchProfile',
      'fetchUseCases',
      'fetchQuotes',
      'fetchResources',
      'fetchSupport',
      'fetchButton',
      'fetchMediaContent',
    ]),

    fetchData() {
      this.fetchProfile(this.$route.params.name);
      this.fetchMediaContent(this.$route.params.name);
      this.fetchUseCases(this.$route.params.name);
      this.fetchQuotes(this.$route.params.name);
      this.fetchResources(this.$route.params.name);
      this.fetchSupport(this.$route.params.name);
      this.fetchButton(this.$route.params.name);
    },

    discardChanges() {
      this.fetchData();
      this.$store.commit('integrationPartners/clearDirty');
      this.$store.commit('integrationPartners/clearErrors');
      this.discardModalOpen = false;
      this.aboutSectionKey += 1;
    },

    deleteContent(payload) {
      this.toDelete = payload;
      this.modalOpen = {
        title: payload.modalTitle,
        description: payload.modalDescription,
      };
      this.deleteType = payload.section;
    },
    confirmedDelete() {
      if (this.deleteType === 'media') {
        this.$store.dispatch(
          'integrationPartners/deleteItemForMedia',
          this.toDelete
        );
      }

      if (this.deleteType === 'video') {
        this.$store.dispatch('integrationPartners/deleteVideo', this.toDelete);
      }

      if (this.deleteType === 'testimonials') {
        this.$store.dispatch(
          'integrationPartners/deleteItemForTestimonial',
          this.toDelete
        );
      }

      if (this.deleteType === 'resources') {
        this.$store.dispatch(
          'integrationPartners/deleteItemForResources',
          this.toDelete
        );
      }

      if (this.deleteType === 'useCases') {
        this.$store.dispatch(
          'integrationPartners/deleteItemForUseCases',
          this.toDelete
        );
      }

      this.modalOpen = false;
      this.toDelete = false;
    },
    badgeStatusFilter(filter) {
      return this.$options.filters[filter](this.profileData.status);
    },
  },
  created() {
    this.fetchData();
  },
  computed: {
    ...mapGetters({
      profileData: 'integrationPartners/profileData',
      isProfilePublic: 'integrationPartners/isProfilePublic',
      profileUrl: 'integrationPartners/profileUrl',
      details: 'details',
      showHeaderBar: 'integrationPartners/showHeaderBar',
      testimonials: 'integrationPartners/quotes',
    }),
    vendor() {
      return this.$route.params.name;
    },
  },
  beforeRouteLeave(to, from, next) {
    this.clearPartner();
    next();
  },
};
</script>

<style lang="scss" scoped>
.route-enter-active,
.route-leave-active {
  transition-duration: 0.1s;
  transition-property: all;
  transition-timing-function: ease;
}

.route-enter-active {
  transition-delay: 0.1s;
}

.route-enter,
.route-leave-active {
  opacity: 0;
}
</style>
